import React, { useMemo } from 'react';
import { translate } from '../../services/translate';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../FormDropDownPicker';

type Props = {

    zIndex: number;
    disabled: boolean;
    required: boolean;
    labelFontSize: number;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: VideoStorageTime;
    setValue: React.Dispatch<React.SetStateAction<VideoStorageTime>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function VideoStorageTimeDropdown({ value, setValue, zIndex, disabled, required, labelFontSize, fieldName, form }: Props) {
    const items = useMemo(() => {
        const options = [{
            label: '30_days',
            value: '30'
        }, {
            label: '15_days',
            value: '15'
        },];

        return options.map(type => ({ label: translate(type.label), value: type.value }));
    }, []);

    if (form && fieldName) {
        return <FormDropDownPicker
            label={translate('videoStorageTime')}
            items={items}
            multiple={false}
            fieldName={fieldName}
            form={form}
            zIndex={zIndex}
            disabled={disabled}
            labelFontSize={labelFontSize}
            required={required}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return <FilterDropdown
            label={translate('videoStorageTime')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            disabled={disabled}
            required={required}
            labelFontSize={labelFontSize}
        />;
    }
}

export default VideoStorageTimeDropdown;
